import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { PaymentInfoService } from 'src/app/services/payment-info.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { ErrorComponent } from '../error/error.component';

@Component({
  selector: 'app-check-transaction-status',
  templateUrl: './check-transaction-status.component.html',
  styleUrls: ['./check-transaction-status.component.scss']
})
export class CheckTransactionStatusComponent implements OnInit {
  currentLanguage: any;
  trackReqData: any;
  paymentMethod: string;

  constructor(
    private PIS: PaymentInfoService,
    private modalController: ModalController,
    private route: Router,
    private UTS:UtilitiesService,
    private SS: SubjectService) { }

    ngOnInit() {
      this.currentLanguage = this.UTS.getLocaleLanguage();
      this.trackReqData = JSON.parse(localStorage.getItem('TR'));
      this.paymentMethod = localStorage.getItem('paymentMethod')
      if( this.paymentMethod == 'newCreditDebtCard' ||
          this.paymentMethod == 'creditDebtCard' || 
          this.paymentMethod == 'bankTransfer' ) {
          this.finalizePayment()
          }
    }
  finalizePayment(){
    this.PIS.finalizePayment().subscribe((r: any) => {
      if (r) { 
        let language = sessionStorage.getItem('language') || localStorage.getItem('language') || 'en';
        this.route.navigate(['success'], { queryParams: { flow: 'payment', from: 'ONLINEPAYMENT', locale: language } });
      }
    }, (e) => {
      // this.UTS.error('Something went wrong');
      this.SS.addonBuyError.next('Something went wrong');
      this.openBottomSheet(ErrorComponent,{errorCode:'epgFailure'})
      let language = sessionStorage.getItem('language') || localStorage.getItem('language') || 'en';
      this.route.navigateByUrl('/track-request/payment?locale='+language)
    })
  }

  
  async openBottomSheet(component: any, data?: any) {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { data: data },
      // mode: "ios",
      cssClass: 'verification-modal modal-fullscreen',
    });
    return await modal.present();
  }
}
